import React, { useState } from 'react';
import {
 Heading,
 Box,
 Button,
 Flex,
 TableContainer,
 Table,
 Thead,
 Tbody,
 Tr,
 Td,
 Th,
 useToast,
} from '@chakra-ui/react';
import { AttentionModal, SuccessModal } from '../Modals';
import baseService from '../../services/base';
import { fetchData } from '../../services/fetch';
import useSWR from 'swr';
import CertificationSelectModal from '../Modals/CertificationSelectModal';
import { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { useSSO } from '../../context/SSO';
registerLocale('pt-BR', ptBR);

export default function CertificationsTable({ companyRegister, idCompanyGroup }) {
 const toast = useToast();
 const { user } = useSSO();

 const [modalIsOpen, setModalIsOpen] = useState(false);
 const [selectedCertification, setSelectedCertification] = useState();
 const [isEditing, setIsEditing] = useState(false);
 const [confirmationModalIsOpen, setConfirmationModalIsOpen] = useState(false);
 const [successModalOpen, setSuccessModalOpen] = useState(false);
 const [confirmationModalIsLoading, setConfirmationModalIsLoading] = useState(false);

 const { data: companieCertifications, mutate } = useSWR(
  idCompanyGroup ? `certificate/link-group/${idCompanyGroup}` : null,
  fetchData,
  {
   onErrorRetry: (error) => {
    // Nunca tentar ao 404.
    if (error.status === 404) return;
   },
  }
 );

 function handleAddOpen() {
  setIsEditing(false);
  setModalIsOpen(true);
 }

 function handleEdit(certification) {
  setIsEditing(true);
  setSelectedCertification(certification);
  setModalIsOpen(true);
 }

 async function removeCertification(certificationId) {
  setConfirmationModalIsLoading(true);
  try {
   await baseService.delete(`/certificate/group-link/${certificationId}`);

   setConfirmationModalIsOpen(false);
   setSuccessModalOpen(true);
  } catch (err) {
   toast({
    title: 'Não foi possível remover a certificação',
    status: 'error',
   });
  } finally {
   setConfirmationModalIsLoading(false);
   setSelectedCertification(null);
  }
 }

 async function removeSurvey() {
  if (selectedCertification) {
   await removeCertification(selectedCertification?.id_link);
  }
 }

 const handleCloseSuccess = () => {
  setSuccessModalOpen(false);
  mutate();
 };

 const closeFormModal = () => {
  setModalIsOpen(false);
  setIsEditing(false);
  setSelectedCertification(null);
 };

 const handleCloseConfirmation = () => {
  setConfirmationModalIsOpen(false);
  setSelectedCertification(null);
 };

 const certificationsList = Array.isArray(companieCertifications) ? companieCertifications : [];

 const formatDate = (dateString) => {
  if (!dateString) return '--';
  const date = parseISO(dateString);
  return format(date, 'dd/MM/yyyy');
 };

 return (
  <Box>
   <Flex h='56px' justify={'space-between'} align='center' marginBottom='28px'>
    <Heading as='h2' fontSize='20px' lineHeight='24.8px'>
     Certificações para respondentes
    </Heading>

    <Button
     onClick={handleAddOpen}
     variant='primary'
     w='231px'
     height='56px'
     isDisabled={!companyRegister}
    >
     Adicionar certificação
    </Button>
   </Flex>

   <TableContainer>
    <Table>
     <Thead height='51px' bg='#EAEAEA' p={0}>
      <Tr p={0} fontWeight={500}>
       <Th fontSize='15px' lineHeight='19.38px' color='black.100' w='30%'>
        Nome da Certificação
       </Th>
       <Th fontSize='15px' lineHeight='19.38px' color='black.100' w='15%'>
        Exercício
       </Th>
       <Th fontSize='15px' lineHeight='19.38px' color='black.100' w='20%'>
        Prazo inicial
       </Th>
       <Th fontSize='15px' lineHeight='19.38px' color='black.100' width='15%'>
        Prazo final
       </Th>
       <Th fontSize='15px' lineHeight='19.38px' color='black.100' w='20%'>
        Ações
       </Th>
      </Tr>
     </Thead>

     <Tbody>
      {certificationsList.map((certification) => (
       <Tr
        key={certification?.id_certificate}
        borderBlock='1px solid rgba(0,0,0,0)'
        height='48px'
        fontWeight={500}
        padding='0px 24px'
       >
        <Td fontSize='sm' fontWeight={600} whiteSpace='nowrap' py='8px'>
         {certification?.name}
        </Td>

        <Td whiteSpace='nowrap' py='8px'>
         {certification?.exercise ?? '--'}
        </Td>

        <Td whiteSpace='nowrap' py='8px'>
         {formatDate(certification?.period)}
        </Td>
        <Td whiteSpace='nowrap' py='8px'>
         {formatDate(certification?.end_application_date)}
        </Td>
        <Td p='4' display='flex' alignItems='center' gap='13px'>
         <Button
          p='0 11px'
          h='29px'
          fontSize='sm'
          fontWeight='600'
          color='white'
          bg='#0173BC'
          _hover={{
           bg: '#0173BC',
          }}
          onClick={() => handleEdit(certification)}
         >
          Editar
         </Button>
         <Button
          p='0 11px'
          h='29px'
          fontSize='sm'
          fontWeight='600'
          color='white'
          bg='#FF6700'
          _hover={{
           bg: '#FF6700',
          }}
          onClick={() => {
           setSelectedCertification(certification);
           setConfirmationModalIsOpen(true);
          }}
         >
          Remover
         </Button>
         {/* <TableMenu
          menuItems={[
           {
            label: 'Remover',
            handler: () => {
             setSelectedCertification(certification);
             setConfirmationModalIsOpen(true);
            },
           },
           //  {
           //   label: 'Editar',
           //   handler: () => handleEdit(certification),
           //  },

           // {px
           //   label: "Respondentes",
           //   handler: () =>
           //     navigate(
           //       `/registration/company/respondents/${form.s_id_survey}?cr=${companyRegister}&cg=${idCompanyGroup}`
           //     ),
           // },
          ]}
         /> */}
        </Td>
       </Tr>
      ))}
     </Tbody>
    </Table>
   </TableContainer>
   {modalIsOpen && (
    <CertificationSelectModal
     onClose={closeFormModal}
     isOpen={modalIsOpen}
     isEditing={isEditing}
     idCompanyGroup={idCompanyGroup}
     companieCertifications={certificationsList}
     editCertification={selectedCertification}
     mutate={mutate}
     userId={user?.user?.id_user}
     companyId={companyRegister}
     roleId={1}
    />
   )}

   <AttentionModal
    isOpen={confirmationModalIsOpen}
    onClose={handleCloseConfirmation}
    submit={removeSurvey}
    title='Deseja remover a certificação vinculada?'
    isLoading={confirmationModalIsLoading}
   />

   <SuccessModal
    isOpen={successModalOpen}
    onClose={handleCloseSuccess}
    title={'Certificação removida com sucesso'}
   />
  </Box>
 );
}
